const active = 'active';
const expanded = 'in';
const filtered = 'filtered';
const show = 'show';
const hide = 'hide';
const collapsed = 'collapsed';
